
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("hU34N", function(module, exports) {
/* AISmartButtonWrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $5spQU = parcelRequire("5spQU");


var $gdv5Z = parcelRequire("gdv5Z");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");





var $fFa3V = parcelRequire("fFa3V");


var $1Whri = parcelRequire("1Whri");


var $dh538 = parcelRequire("dh538");








var $2YmgJ = parcelRequire("2YmgJ");


var $4acD6 = parcelRequire("4acD6");

const $ee1acdbba6f5287a$export$cb9c0d3b5896f957 = ()=>{
    const { setButtonClickedTimestamp: setButtonClickedTimestamp } = (0, $4acD6.useAISmartButtonActions)();
    const conversationActionsStoreActions = (0, $2YmgJ.useConversationActionsStoreActions)();
    return (0, $42omo.useMemo)(()=>({
            /**
			 * Set the button clicked timestamp for the source.
			 */ setButtonClickedTimestamp: (buttonClickedTimestamp)=>{
                setButtonClickedTimestamp(buttonClickedTimestamp);
                conversationActionsStoreActions.setButtonClickedTimestamp(buttonClickedTimestamp);
            }
        }), [
        setButtonClickedTimestamp,
        conversationActionsStoreActions
    ]);
};









var $c6GJD = parcelRequire("c6GJD");





var $i25hX = parcelRequire("i25hX");


var $aMqwg = parcelRequire("aMqwg");


var $5gEqE = parcelRequire("5gEqE");


var $e96kn = parcelRequire("e96kn");


var $6Htct = parcelRequire("6Htct");

/**
 * Isomorphic SSR-safe check if code is run in the browser environment
 * so we can use globals like window safely.
 */ const $1bbe1fac07a514e1$export$4e09c449d6c407f7 = ()=>{
    try {
        return typeof window !== 'undefined';
    } catch  {
        // Catch possible error that might occur and just return false
        return false;
    }
};



var $s5sAh = parcelRequire("s5sAh");

// If productionized - will consider relocating logic to conversion-assistant-onboarding -- tracking ticket: https://hello.jira.atlassian.cloud/browse/MOOG-146
const $635ac85d8e192d37$var$ELIGIBLE_PAGES = [
    (0, $6Htct.PageContextType).JIRA_FOR_YOU,
    (0, $6Htct.PageContextType).JIRA_ISSUE_VIEW,
    (0, $6Htct.PageContextType).JIRA_PROJECT
];
const $635ac85d8e192d37$var$ELIGIBLE_PRODUCTS = [
    'jira'
];
const $635ac85d8e192d37$var$DWELL_TIME_MS = 5000;
const $635ac85d8e192d37$export$20c376cddbc7272c = ({ product: product })=>{
    if ((0, $1bbe1fac07a514e1$export$4e09c449d6c407f7)() && (0, $dh538.fg)('rovo_onboarding_modal_jira_chat_fg')) return /*#__PURE__*/ (0, $l998X.jsx)($635ac85d8e192d37$var$OnboardingEnablementInner, {
        product: product
    });
    return null;
};
const $635ac85d8e192d37$var$OnboardingEnablementInner = ({ product: product })=>{
    $635ac85d8e192d37$var$useOnboardingEnablement({
        product: product
    });
    return null;
};
function $635ac85d8e192d37$var$useOnboardingEnablement({ product: product }) {
    const pageContextType = (0, $e96kn.usePageContextType)();
    const { isRovoEnabled: isRovoEnabled } = (0, $aMqwg.useRovoEntitlement)();
    const { mounted: isChatOpen, setIsChatOnboardingMiniModalOpen: setIsChatOnboardingMiniModalOpen } = (0, $5gEqE.useUIStore)();
    const publish = (0, $i25hX.usePublish)('ai-mate');
    const hasOpenedChatRef = (0, $42omo.useRef)(false);
    const routeDwellTimerRef = (0, $42omo.useRef)(null);
    const [hasDwelled, setHasDwelled] = (0, $42omo.useState)(false);
    const [passesHoldout] = (0, $42omo.useState)((0, $s5sAh.passesOnboardingHoldout));
    const isFeatureGateEnabled = (0, $dh538.fg)('rovo_onboarding_modal_jira_chat_fg');
    const isEligiblePage = $635ac85d8e192d37$var$ELIGIBLE_PAGES.includes(pageContextType);
    const isEligibleProduct = $635ac85d8e192d37$var$ELIGIBLE_PRODUCTS.includes(product);
    // Track if chat has been opened
    (0, $42omo.useEffect)(()=>{
        if (isChatOpen && !hasOpenedChatRef.current) hasOpenedChatRef.current = true;
    }, [
        isChatOpen
    ]);
    // Dwell timer effect - only runs when basic eligibility is met
    (0, $42omo.useEffect)(()=>{
        const shouldSkipTimer = hasOpenedChatRef.current || !passesHoldout || !isFeatureGateEnabled || !isRovoEnabled || !isEligiblePage || !isEligibleProduct;
        if (shouldSkipTimer) return;
        // Reset dwell status when route changes
        setHasDwelled(false);
        // Clear any existing timer
        if (routeDwellTimerRef.current) {
            clearTimeout(routeDwellTimerRef.current);
            routeDwellTimerRef.current = null;
        }
        // Start new timer for current route
        routeDwellTimerRef.current = setTimeout(()=>{
            setHasDwelled(true);
            routeDwellTimerRef.current = null;
        }, $635ac85d8e192d37$var$DWELL_TIME_MS);
        // Cleanup on unmount or route change
        return ()=>{
            if (routeDwellTimerRef.current) {
                clearTimeout(routeDwellTimerRef.current);
                routeDwellTimerRef.current = null;
            }
        };
    }, [
        pageContextType,
        isRovoEnabled,
        isFeatureGateEnabled,
        isEligiblePage,
        isEligibleProduct,
        passesHoldout
    ]);
    const isEligible = (0, $42omo.useMemo)(()=>isRovoEnabled && isFeatureGateEnabled && isEligiblePage && isEligibleProduct && hasDwelled && !isChatOpen && passesHoldout, [
        isRovoEnabled,
        isFeatureGateEnabled,
        isEligiblePage,
        isEligibleProduct,
        hasDwelled,
        isChatOpen,
        passesHoldout
    ]);
    (0, $42omo.useEffect)(()=>{
        if (isEligible && !hasOpenedChatRef.current) {
            const cohort = (0, $c6GJD.default).getExperimentValue('rovo_onboarding_modal_jira_chat', 'cohort', '');
            if (cohort === 'variation') {
                hasOpenedChatRef.current = true;
                publish({
                    type: 'chat-draft',
                    product: product,
                    source: 'ai-mate-onboarding',
                    openChat: true,
                    openChatMode: 'mini-modal'
                });
                (0, $s5sAh.recordOnboardingExposureForHoldout)();
                setIsChatOnboardingMiniModalOpen(true);
            }
        }
    }, [
        isEligible,
        product,
        setIsChatOnboardingMiniModalOpen,
        publish
    ]);
}



var $8unJx = parcelRequire("8unJx");


var $2sBZP = parcelRequire("2sBZP");




/**
 * Isomorphic SSR-safe check if code is run in the browser environment
 * so we can use globals like window safely.
 */ const $b154a53ccf449036$export$4e09c449d6c407f7 = ()=>{
    try {
        return typeof window !== 'undefined';
    } catch  {
        // Catch possible error that might occur and just return false
        return false;
    }
};


class $0e33fb5798bfd96d$export$f4380d3820d95f34 {
    get hasTriggers() {
        return Boolean(this.triggerQueue.length);
    }
    addTrigger(featureId, featureName, featureDescription) {
        this.triggerQueue.push({
            nudge_id: crypto.randomUUID(),
            feature_details: {
                feature_id: featureId,
                feature_name: featureName || 'Debug Nudge',
                feature_description: featureDescription || 'A nudge added for debugging'
            },
            cta: {
                cta_action: 'ACTION'
            }
        });
    }
    addConvoStarter(convoStarterLabel) {
        this.triggerQueue.push({
            cta: {
                cta_action: 'CHAT',
                cta_label: convoStarterLabel || 'Debug Convo Starter'
            },
            nudge_id: crypto.randomUUID(),
            feature_details: {
                feature_id: 'convo-starter',
                feature_name: 'Debug Convo Starter',
                feature_description: 'A conversation starter for debugging'
            }
        });
    }
    clear() {
        this.triggerQueue = [];
    }
    useNextTrigger() {
        return this.triggerQueue.shift();
    }
    constructor(){
        this.triggerQueue = [];
    }
}


const $8a1c9f7e7547dacb$export$a8ab20a5170c41b3 = ()=>{
    (0, $42omo.useEffect)(()=>{
        if (!(0, $b154a53ccf449036$export$4e09c449d6c407f7)()) return;
        if (!window?.AIX_DEBUG_NUDGE_TRIGGERS) window.AIX_DEBUG_NUDGE_TRIGGERS = new (0, $0e33fb5798bfd96d$export$f4380d3820d95f34)();
        return ()=>{
            if (window.AIX_DEBUG_NUDGE_TRIGGERS) delete window.AIX_DEBUG_NUDGE_TRIGGERS;
        };
    }, []);
};









var $h26dv = parcelRequire("h26dv");





/**
 * Schedules a callback to run after the browser has painted and is idle.
 *
 * Prefers `requestIdleCallback` when available (all modern browsers except Safari < 16.4),
 * which fires during genuine browser idle time — safe for work that must not impact vc90.
 *
 * Falls back to `requestAnimationFrame` which fires after the next paint — still non-blocking
 * and render-safe, just without the "idle" guarantee.
 *
 * Returns a cleanup function that cancels the scheduled callback, suitable for use as a
 * `useEffect` return value to prevent work firing after component unmount.
 *
 * NOTE: `react-ufo` has an internal `scheduleIdleCallback` utility but it is not a public
 * export and is not intended for reuse outside the UFO package. This utility follows the same
 * pattern already used in `platform/packages/navigation/global-side-navigation`.
 */ function $07731d19b082bfb4$export$9c28ad8c8fd2ff2f(callback) {
    if (typeof requestIdleCallback !== 'undefined') {
        const id = requestIdleCallback(callback);
        return ()=>cancelIdleCallback(id);
    }
    const id = requestAnimationFrame(callback);
    return ()=>cancelAnimationFrame(id);
}


const $9b7a6173fd2ba65c$var$LOOK_BACK_PERIOD_MS = 129600000;
const $9b7a6173fd2ba65c$var$CACHE_TTL_MS = 300000;
const $9b7a6173fd2ba65c$var$CACHE_KEY = 'rovo-button-unread-status-v1';
function $9b7a6173fd2ba65c$var$readCache() {
    if (!(0, $b154a53ccf449036$export$4e09c449d6c407f7)()) return null;
    try {
        const raw = sessionStorage.getItem($9b7a6173fd2ba65c$var$CACHE_KEY);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        // Entries older than TTL are fully expired — discard them
        if (Date.now() - parsed.cachedAt >= $9b7a6173fd2ba65c$var$CACHE_TTL_MS) {
            sessionStorage.removeItem($9b7a6173fd2ba65c$var$CACHE_KEY);
            return null;
        }
        const { cachedAt: _cachedAt, stale: stale, ...result } = parsed;
        // Migrate cache entries written before unreadCount / inProgressCount were added
        const data = {
            ...result,
            unreadCount: result.unreadCount ?? (result.hasUnread ? 1 : 0),
            inProgressCount: result.inProgressCount ?? 0
        };
        return {
            data: data,
            isStale: stale === true
        };
    } catch  {
        return null;
    }
}
function $9b7a6173fd2ba65c$var$writeCache(result) {
    if (!(0, $b154a53ccf449036$export$4e09c449d6c407f7)()) return;
    try {
        const toStore = {
            ...result,
            cachedAt: Date.now()
        };
        sessionStorage.setItem($9b7a6173fd2ba65c$var$CACHE_KEY, JSON.stringify(toStore));
    } catch  {
    // sessionStorage may be unavailable (private browsing quota, etc.) — fail silently
    }
}
function $9b7a6173fd2ba65c$export$5ea316be7514c402() {
    if (!(0, $b154a53ccf449036$export$4e09c449d6c407f7)()) return;
    try {
        const raw = sessionStorage.getItem($9b7a6173fd2ba65c$var$CACHE_KEY);
        if (!raw) return;
        const parsed = JSON.parse(raw);
        sessionStorage.setItem($9b7a6173fd2ba65c$var$CACHE_KEY, JSON.stringify({
            ...parsed,
            stale: true
        }));
    } catch  {
    // sessionStorage may be unavailable — fail silently
    }
}
const $9b7a6173fd2ba65c$var$NO_UNREAD = {
    hasUnread: false,
    unreadCount: 0,
    inProgressCount: 0,
    mostRecentUnread: null
};
function $9b7a6173fd2ba65c$export$e34a0a17cdc941c7({ enabled: enabled, mode: mode }) {
    const [status, setStatus] = (0, $42omo.useState)(()=>enabled ? $9b7a6173fd2ba65c$var$readCache()?.data ?? $9b7a6173fd2ba65c$var$NO_UNREAD : $9b7a6173fd2ba65c$var$NO_UNREAD);
    const { conversationAssistantConfig: conversationAssistantConfig, product: product } = (0, $2sBZP.useAISmartButtonContext)();
    const baseUrl = conversationAssistantConfig?.assistanceServiceConfig?.baseUrl;
    const headers = conversationAssistantConfig?.assistanceServiceConfig?.headers;
    const assistanceService = (0, $42omo.useMemo)(()=>new (0, $h26dv.AssistanceServiceImpl)({
            product: product,
            experienceId: 'ai-mate',
            baseUrl: baseUrl,
            headers: headers
        }), [
        product,
        baseUrl,
        headers
    ]);
    const fetchAndUpdateRef = (0, $42omo.useRef)(async ()=>{});
    const isFetchingRef = (0, $42omo.useRef)(false);
    const prevModeRef = (0, $42omo.useRef)(mode);
    (0, $42omo.useEffect)(()=>{
        if (!enabled) {
            // Reset the in-flight guard so the next enable can fetch immediately.
            // Without this, a fetch that was in-flight when enabled flipped to false
            // would leave isFetchingRef stuck as true, blocking the next fetch.
            isFetchingRef.current = false;
            setStatus($9b7a6173fd2ba65c$var$NO_UNREAD);
            return;
        }
        let cancelled = false;
        const fetchAndUpdate = async ()=>{
            if (isFetchingRef.current) return;
            isFetchingRef.current = true;
            try {
                const cacheResult = $9b7a6173fd2ba65c$var$readCache();
                if (cacheResult) {
                    if (!cancelled) setStatus((prev)=>{
                        if (prev.hasUnread === cacheResult.data.hasUnread && prev.unreadCount === cacheResult.data.unreadCount && prev.inProgressCount === cacheResult.data.inProgressCount) return prev;
                        return cacheResult.data;
                    });
                    if (!cacheResult.isStale) return;
                // stale — fall through to background re-fetch
                }
                const channels = await assistanceService.getConversationChannels();
                if (cancelled) return;
                const inProgressCount = channels.filter((channel)=>channel.last_agent_message_status === 'IN_PROGRESS').length;
                const now = Date.now();
                const recentUnread = channels.filter((channel)=>{
                    // readStatus === false is the explicit unread signal; null means a legacy/old
                    // conversation with no read-tracking — exclude it to avoid false positives.
                    const isUnread = channel.readStatus === false;
                    // Only show indicator for completed agent responses — exclude IN_PROGRESS (streaming),
                    // FAILED, CANCELLED, and legacy channels without this field.
                    const hasSuccessfulAgentMessage = channel.last_agent_message_status === 'SUCCESSFUL';
                    const timestamp = channel.last_message_timestamp;
                    const isRecent = !!timestamp && now - new Date(timestamp).getTime() < $9b7a6173fd2ba65c$var$LOOK_BACK_PERIOD_MS;
                    return isUnread && hasSuccessfulAgentMessage && isRecent;
                }).sort((a, b)=>{
                    const aTime = a.last_message_timestamp ? new Date(a.last_message_timestamp).getTime() : 0;
                    const bTime = b.last_message_timestamp ? new Date(b.last_message_timestamp).getTime() : 0;
                    return bTime - aTime;
                });
                const result = recentUnread.length > 0 ? {
                    hasUnread: true,
                    unreadCount: recentUnread.length,
                    inProgressCount: inProgressCount,
                    mostRecentUnread: {
                        id: String(recentUnread[0].id),
                        name: recentUnread[0].name ?? null
                    }
                } : {
                    hasUnread: false,
                    unreadCount: 0,
                    inProgressCount: inProgressCount,
                    mostRecentUnread: null
                };
                $9b7a6173fd2ba65c$var$writeCache(result);
                setStatus(result);
            } catch  {
            // Fail silently — keep the current displayed status rather than forcing NO_UNREAD.
            // If stale data was being shown, it continues to show — better UX than a false negative.
            } finally{
                isFetchingRef.current = false;
            }
        };
        fetchAndUpdateRef.current = fetchAndUpdate;
        // Defer the initial fetch until after paint/idle (post-vc90 safe)
        const cancelPostPaint = (0, $07731d19b082bfb4$export$9c28ad8c8fd2ff2f)(()=>{
            fetchAndUpdate();
        });
        // Refresh on window focus once the cache has expired
        const unbindFocus = (0, $b154a53ccf449036$export$4e09c449d6c407f7)() ? (0, $fFa3V.bindAll)(window, [
            {
                type: 'focus',
                listener: ()=>{
                    fetchAndUpdate();
                }
            }
        ]) : null;
        return ()=>{
            cancelled = true;
            cancelPostPaint();
            unbindFocus?.();
        };
    }, [
        assistanceService,
        enabled
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!enabled) {
            prevModeRef.current = mode;
            return;
        }
        if (mode === undefined && prevModeRef.current !== undefined) {
            // User closed the sidebar — mark cache stale and re-fetch in the background
            $9b7a6173fd2ba65c$export$5ea316be7514c402();
            fetchAndUpdateRef.current();
        }
        prevModeRef.current = mode;
    }, [
        mode,
        enabled
    ]);
    return status;
}




var $4Zhx7 = parcelRequire("4Zhx7");








var $7fKGk = parcelRequire("7fKGk");




/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");





var $jO3S6 = parcelRequire("jO3S6");


var $b6KjD = parcelRequire("b6KjD");

const $283eb6140a5633fc$var$styles = {
    miniModalMainContainer: "_2rko12b0 _1bsb1kdj _bfhkhp5a _16qs130s _1e0c1txw _4cvr1h6o _1bah1h6o",
    rovoIcon: "_1bsbckbl _4t3ickbl"
};
const $283eb6140a5633fc$export$a33efecb32878e39 = ({ topOffset: topOffset, isNav4Enabled: isNav4Enabled })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $b6KjD.MainWrapper), {
        mode: "mini-modal",
        isNav4Enabled: isNav4Enabled,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            testId: "conversation-assistant-mini-modal-main-container",
            xcss: $283eb6140a5633fc$var$styles.miniModalMainContainer,
            style: {
                height: `min(320px, calc(100vh - ${topOffset}px))`
            },
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $283eb6140a5633fc$var$styles.rovoIcon,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $jO3S6.LazyAnimatedRovoIcon), {
                    alt: "",
                    testId: "rovo-loading-animation"
                })
            })
        })
    });
};






const $6aab261d18fe5fed$var$LazyAIMiniModal = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("avMJB")).then((module)=>({
            default: module.AIMiniModal
        })));

const $6aab261d18fe5fed$export$1f1f17d801cbb952 = ()=>{
    (parcelRequire("avMJB")).then((module)=>({
            default: module.AIMiniModal
        }));
};
const $6aab261d18fe5fed$export$f36d8da28b18d2c1 = ()=>{
    const context = (0, $2sBZP.useAISmartButtonContext)();
    const mousetrapRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(null);
    const setContainerRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((node)=>{
        mousetrapRef.current?.reset();
        if (!node) return;
        mousetrapRef.current = new (0, (/*@__PURE__*/$parcel$interopDefault($7fKGk)))(node);
    }, []);
    const suppressKeyPress = (event)=>{
        mousetrapRef.current?.bind(event.key.toLocaleLowerCase(), (e)=>e.stopPropagation());
    };
    const miniModal = (0, $42omo.useMemo)(()=>{
        // 48px = nav header height, 8px = object sidebar bottom padding, 16px = AI smart button bottom margin, 8px = extra margin so it doesn't align with nav header
        const defaultTopOffset = 80;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Suspense, {
            fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $283eb6140a5633fc$export$a33efecb32878e39), {
                topOffset: context.topOffset || defaultTopOffset,
                isNav4Enabled: context.isNav4Enabled
            }),
            children: /*#__PURE__*/ (0, $l998X.jsx)($6aab261d18fe5fed$var$LazyAIMiniModal, {})
        });
    }, [
        context
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        ref: setContainerRef,
        onKeyDown: suppressKeyPress,
        testId: "ai-smart-button-mini-modal-wrapper",
        children: context.overrideMiniModalWrapper ? context.overrideMiniModalWrapper(miniModal) : miniModal
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");








var $aXWIB = parcelRequire("aXWIB");


var $hTKp4 = parcelRequire("hTKp4");





var $g9Srd = parcelRequire("g9Srd");





var $u9agA = parcelRequire("u9agA");


var $3gadb = parcelRequire("3gadb");












/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ /* eslint-disable @atlaskit/ui-styling-standard/no-classname-prop */ 









var $fT2ta = parcelRequire("fT2ta");









/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 






const $5b156f12209d425b$var$LazyAIActionShortcut = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("7cG9Q")).then((module)=>({
            default: module.AIActionShortcut
        })));
const $5b156f12209d425b$export$2966057c342a8370 = ({ action: action })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)($5b156f12209d425b$var$LazyAIActionShortcut, {
        action: action
    });
};


const $1818afbf5519aa2a$var$styles = {
    actionsWrapperStyles: "_zulp1b66 _kqswstnw _1xi21osq _2hwxu2gc _94n5ze3t _1e0c1txw _2lx21bp4 _4cvresu3"
};
const $1818afbf5519aa2a$export$fa41c7e6bc1d5bc2 = ({ actionShortcuts: actionShortcuts, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave })=>{
    const { product: product, analyticsAttributes: analyticsAttributes } = (0, $2sBZP.useAISmartButtonContext)();
    const { fireRovoButtonUIEvent: fireRovoButtonUIEvent } = (0, $4Zhx7.useRovoButtonEventsInstrumentation)();
    const { isExiting: isExiting } = (0, $g9Srd.useExitingPersistence)();
    (0, $42omo.useEffect)(()=>{
        fireRovoButtonUIEvent({
            source: analyticsAttributes?.productPage ?? product,
            action: 'rendered',
            actionSubject: 'rovoButton',
            actionSubjectId: 'aiRovoActionShortcutMenu',
            attributes: {
                ...analyticsAttributes,
                version: 'refresh',
                actionIdsRendered: actionShortcuts.map((action)=>action.id)
            },
            product: product
        });
    }, [
        actionShortcuts,
        analyticsAttributes,
        product,
        fireRovoButtonUIEvent
    ]);
    return(// Suspense needed here to avoid rendering empty menu when action shortcuts are loading (since they are lazy loaded)
    /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Suspense, {
        fallback: null,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fT2ta.default), {
            duration: "large",
            entranceDirection: "right",
            exitDirection: "right",
            children: (props)=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
                    ref: props.ref,
                    className: (0, $gMc0m.default)([
                        $1818afbf5519aa2a$var$styles.actionsWrapperStyles,
                        props.className
                    ]),
                    style: {
                        ...props.style,
                        // Prevent hover events during exit animation to avoid flicker.
                        // ExitingPersistence keeps elements mounted while exiting, so without this,
                        // the exiting menu can re-trigger hover handlers and cause flickering.
                        pointerEvents: isExiting ? 'none' : undefined
                    },
                    onMouseEnter: onMouseEnter,
                    onMouseLeave: onMouseLeave,
                    onFocus: onMouseEnter,
                    onBlur: (e)=>{
                        if (!e.currentTarget.contains(e.relatedTarget)) // Only call onMouseLeave if focus is moving outside the container
                        onMouseLeave();
                    },
                    children: actionShortcuts.map((action)=>{
                        return /*#__PURE__*/ (0, $l998X.jsx)((0, $5b156f12209d425b$export$2966057c342a8370), {
                            action: action
                        }, action.id);
                    })
                })
        })
    }));
};



var $3DxCm = parcelRequire("3DxCm");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $9zUhf = parcelRequire("9zUhf");




const $9fe72367d410ea7b$export$b854997b7299d67f = (0, $9zUhf.createStateHook)((0, $4acD6.AISmartButtonStore), {
    selector: (state)=>state.nudges
});
const $9fe72367d410ea7b$export$9af0fbebebbfec35 = (0, $9zUhf.createStateHook)((0, $4acD6.AISmartButtonStore), {
    selector: (state)=>state.buttonClickedTimestamp
});







var $8Uc75 = parcelRequire("8Uc75");








// TODO: Extract and use factory pattern for different trigger types.
const $5e7b02b5f087e233$var$ROVO_BUTTON_TRIGGER_TYPE = 'ROVO_BUTTON_NUDGE_PAGE_LOAD';
const $5e7b02b5f087e233$var$CONVO_AI_URL = '/gateway/api/assist/api/ai/v2/ai-feature/proactive';
const $5e7b02b5f087e233$export$921bdedcb199d207 = async ({ triggerId: triggerId, pageUrl: pageUrl, product: product })=>{
    if ((0, $b154a53ccf449036$export$4e09c449d6c407f7)() && window.AIX_DEBUG_NUDGE_TRIGGERS?.hasTriggers) return {
        triggers: [
            {
                recommendations: [
                    {
                        recommendation_details: window.AIX_DEBUG_NUDGE_TRIGGERS?.useNextTrigger()
                    }
                ]
            }
        ]
    };
    const request = {
        ai_feature_input: {
            triggers: [
                {
                    trigger_id: triggerId,
                    trigger_details: {
                        page_url: pageUrl
                    },
                    trigger_type: $5e7b02b5f087e233$var$ROVO_BUTTON_TRIGGER_TYPE
                }
            ]
        }
    };
    const response = await fetch($5e7b02b5f087e233$var$CONVO_AI_URL, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'X-Product': product,
            'X-Experience-Id': 'proactive-ai-rovo-button'
        },
        body: JSON.stringify(request)
    });
    if (!response.ok) throw new Error(`Error fetching agent recommendations and convo starters, status code: ${response.status}`);
    // Allow error to raise if response is not valid JSON
    // Allow undefined to be returned if ai_feature_output is not present
    return (await response.json())?.ai_feature_output;
};


const $1a4e839fd8f453aa$var$DEFAULT_NUDGE_RECOMMENDATION_CACHE_TTL_MS = 600000;
const $1a4e839fd8f453aa$var$getNudgeRecommendationCacheTTL = ()=>(0, $c6GJD.default).getExperimentValue('page_catchup_cache_ttl', 'value', $1a4e839fd8f453aa$var$DEFAULT_NUDGE_RECOMMENDATION_CACHE_TTL_MS);
const $1a4e839fd8f453aa$var$isPageCatchupCacheTTLExperimentEnabled = (hasPageCatchupNudge)=>{
    if (!hasPageCatchupNudge) return false;
    return (0, $c6GJD.default).getExperimentValue('add_cache_ttl_for_page_catchup_nudge_experiment', 'isEnabled', false);
};
const $1a4e839fd8f453aa$export$dbee8b6a491a53c = (triggerId, shouldTrigger, pageUrl, product, hasPageCatchupNudge = false)=>{
    const [error, setError] = (0, $42omo.useState)();
    const [loading, setLoading] = (0, $42omo.useState)(true);
    const [recommendations, setRecommendations] = (0, $42omo.useState)(undefined);
    const [previousRequestCache, setPreviousRequestCache] = (0, $42omo.useState)({});
    const makeNudgeRecommendationsRequest = (0, $42omo.useCallback)(async ()=>{
        const isSamePageRequest = pageUrl === previousRequestCache.pageUrl;
        const isDuplicateRequestWithinCacheTTL = isSamePageRequest && typeof previousRequestCache.cachedAt === 'number' && Date.now() - previousRequestCache.cachedAt < $1a4e839fd8f453aa$var$getNudgeRecommendationCacheTTL();
        const shouldSkipDuplicatePageRequest = $1a4e839fd8f453aa$var$isPageCatchupCacheTTLExperimentEnabled(hasPageCatchupNudge) ? isDuplicateRequestWithinCacheTTL : isSamePageRequest;
        if (product !== 'confluence' || pageUrl.includes('/wiki/search')) {
            // Temporary: only Confluence is migrated to new nudging system
            // Temporary: added search to skip nudge BE
            setLoading(false);
            return;
        }
        if (!product || // invalid request parameter
        !shouldTrigger || // unsupported, no nudges to recommend
        shouldSkipDuplicatePageRequest // prevent duplicate page requests
        ) {
            setLoading(false);
            return;
        }
        // Begin new request under valid conditions
        if (!loading && product && shouldTrigger && !shouldSkipDuplicatePageRequest) {
            setLoading(true);
            setError(undefined);
            setRecommendations(undefined);
            return;
        }
        try {
            const response = await (0, $5e7b02b5f087e233$export$921bdedcb199d207)({
                triggerId: triggerId,
                pageUrl: pageUrl,
                product: product
            });
            setRecommendations(response?.triggers.flatMap((trigger)=>trigger.recommendations.map((recommendation)=>recommendation.recommendation_details)));
            setError(undefined);
        } catch (error) {
            setRecommendations(undefined);
            setError(error);
        } finally{
            setPreviousRequestCache({
                pageUrl: pageUrl,
                cachedAt: Date.now()
            });
            setLoading(false);
        }
    }, [
        loading,
        pageUrl,
        previousRequestCache,
        product,
        shouldTrigger,
        triggerId,
        hasPageCatchupNudge
    ]);
    (0, $42omo.useEffect)(()=>{
        makeNudgeRecommendationsRequest();
    }, [
        loading,
        makeNudgeRecommendationsRequest
    ]);
    return (0, $42omo.useMemo)(()=>({
            recommendations: loading ? undefined : recommendations,
            loading: loading,
            error: error
        }), [
        loading,
        error,
        recommendations
    ]);
};





parcelRequire("42omo");


var $lDwiy = parcelRequire("lDwiy");







const $a39089d46a09f173$export$ff61339971a5979d = (recommendation)=>{
    const label = recommendation.cta.cta_label;
    if (!label) return undefined;
    return {
        id: (0, $8Uc75.CONVO_STARTER_ID),
        title: label,
        icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lDwiy))), {
                label: ""
            }),
        type: 'convo-starter-action',
        staticPrompt: label,
        starterType: 'static',
        handleType: (0, $6Htct.HandleActionType).Chat
    };
};


const $63ad291e174b6655$export$17110c9fdd9f02a6 = (nudge, recommendation)=>{
    if (nudge.type === 'convo-starter-action') {
        const enriched = (0, $a39089d46a09f173$export$ff61339971a5979d)(recommendation);
        if (!enriched) return undefined;
        return {
            ...enriched,
            recommendationNudgeId: nudge.recommendationNudgeId
        };
    }
    return nudge;
};


const $8d5bf81296446f89$export$6c62f9c964ed3ae0 = (recommendations, availableNudges)=>{
    for (const recommendation of recommendations){
        // Primary match: nudge registered with id matching the BE feature_id
        const matchedNudge = availableNudges.find((nudge)=>nudge.id === recommendation.feature_details.feature_id);
        // Fallback match: nudge registered with nudgeContext.id matching the BE feature_id.
        // This exists because some nudge types use nudgeContext.id instead of id for matching —
        // a data model inconsistency that should be unified.
        const matchedNudgeByContextId = availableNudges.find((action)=>action.nudgeContext?.id === recommendation.feature_details.feature_id);
        if (matchedNudge) {
            const enriched = (0, $63ad291e174b6655$export$17110c9fdd9f02a6)({
                ...matchedNudge,
                recommendationNudgeId: recommendation.nudge_id
            }, recommendation);
            if (enriched) return enriched;
        }
        if (matchedNudgeByContextId) {
            const enriched = (0, $63ad291e174b6655$export$17110c9fdd9f02a6)({
                ...matchedNudgeByContextId,
                recommendationNudgeId: recommendation.nudge_id
            }, recommendation);
            if (enriched) return enriched;
        }
    }
    return undefined;
};












/**
 * The state only resets when:
 * - Location Changes: User navigates to a different page
 * - Page Refresh: Browser refreshes the page (global variables reset)
 * What Doesn't Reset the State
 * - Component Re-renders: State persists
 * - Component Unmount/Remount: State persists (this is what you want)
 * - Button Disappears/Reappears: State persists
 */ let $e430aebe3c00b212$var$globalAcceptedNudges = [];
let $e430aebe3c00b212$var$globalDismissedNudges = [];
const $e430aebe3c00b212$export$2dd8f6b7dbe1b931 = ()=>{
    $e430aebe3c00b212$var$globalAcceptedNudges = [];
    $e430aebe3c00b212$var$globalDismissedNudges = [];
};
const $e430aebe3c00b212$export$2bad233bdabe73c4 = ()=>{
    const { setNudges: setNudges } = (0, $4acD6.useAISmartButtonActions)();
    const [location, setLocation] = (0, $42omo.useState)((0, $b154a53ccf449036$export$4e09c449d6c407f7)() ? window.location.pathname : undefined);
    const [acceptedNudges, setAcceptedNudges] = (0, $42omo.useState)($e430aebe3c00b212$var$globalAcceptedNudges);
    const [dismissedNudges, setDismissedNudges] = (0, $42omo.useState)($e430aebe3c00b212$var$globalDismissedNudges);
    // Helper functions
    const addAcceptedNudge = (0, $42omo.useCallback)((id)=>{
        setAcceptedNudges((prev)=>{
            if (!prev.includes(id)) {
                const newNudges = [
                    ...prev,
                    id
                ];
                $e430aebe3c00b212$var$globalAcceptedNudges = newNudges;
                return newNudges;
            }
            return prev;
        });
    }, []);
    const addDismissedNudge = (0, $42omo.useCallback)((id)=>{
        setDismissedNudges((prev)=>{
            if (!prev.includes(id)) {
                const newNudges = [
                    ...prev,
                    id
                ];
                $e430aebe3c00b212$var$globalDismissedNudges = newNudges;
                return newNudges;
            }
            return prev;
        });
    }, []);
    const clearState = (0, $42omo.useCallback)(()=>{
        setNudges([]);
        setAcceptedNudges([]);
        setDismissedNudges([]);
        $e430aebe3c00b212$var$globalAcceptedNudges = [];
        $e430aebe3c00b212$var$globalDismissedNudges = [];
    }, [
        setNudges
    ]);
    const handleLocationChange = (0, $42omo.useCallback)(()=>{
        if (!(0, $b154a53ccf449036$export$4e09c449d6c407f7)()) return;
        if (location !== window.location.pathname) {
            setLocation(window.location.pathname);
            clearState();
        }
    }, [
        clearState,
        location,
        setLocation
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!(0, $b154a53ccf449036$export$4e09c449d6c407f7)()) return;
        const originalPushState = window.history.pushState;
        const originalReplaceState = window.history.replaceState;
        window.history.pushState = function(...args) {
            originalPushState.apply(this, args);
            handleLocationChange();
        };
        window.history.replaceState = function(...args) {
            originalReplaceState.apply(this, args);
            handleLocationChange();
        };
        const unbind = (0, $fFa3V.bindAll)(window, [
            {
                type: 'popstate',
                listener: handleLocationChange
            }
        ]);
        return ()=>{
            if (!(0, $b154a53ccf449036$export$4e09c449d6c407f7)()) return;
            unbind();
            window.history.pushState = originalPushState;
            window.history.replaceState = originalReplaceState;
        };
    }, [
        handleLocationChange
    ]);
    return {
        acceptedNudges: acceptedNudges,
        dismissedNudges: dismissedNudges,
        addAcceptedNudge: addAcceptedNudge,
        addDismissedNudge: addDismissedNudge,
        clearState: clearState
    };
};


const $2b8cbdbf5555f0cb$var$messages = (0, $aXWIB.defineMessages)({
    convoStarterSubheader: {
        id: "ai-smart-button.convo-starter.nudge.subheader",
        defaultMessage: "Open Rovo chat with this page-specific starter"
    }
}); // Lazy load to avoid loading useRovoActionTrigger when there's no active nudge

const $2b8cbdbf5555f0cb$var$LazyAIProactiveNudge = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("3xhLJ")).then((module)=>({
            default: module.AIProactiveNudge
        })));
const $2b8cbdbf5555f0cb$export$50a342ac0fc7ff57 = ({ onActiveNudgeChange: onActiveNudgeChange })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { product: product } = (0, $2sBZP.useAISmartButtonContext)();
    const [triggerId] = (0, $42omo.useState)(()=>crypto.randomUUID());
    const selectedNudges = (0, $9fe72367d410ea7b$export$b854997b7299d67f)();
    const shouldTrigger = Boolean(selectedNudges?.length);
    const hasPageCatchupNudge = selectedNudges?.some((nudge)=>nudge.nudgeContext?.id === 'content-catchup') ?? false;
    const pageUrl = (0, $b154a53ccf449036$export$4e09c449d6c407f7)() ? `${window.location.origin}${window.location.pathname}` : '';
    const { recommendations: recommendations, loading: loading, error: error } = (0, $1a4e839fd8f453aa$export$dbee8b6a491a53c)(triggerId, shouldTrigger, pageUrl, product, hasPageCatchupNudge);
    const { acceptedNudges: acceptedNudges, dismissedNudges: dismissedNudges, addAcceptedNudge: addAcceptedNudge, addDismissedNudge: addDismissedNudge } = (0, $e430aebe3c00b212$export$2bad233bdabe73c4)();
    const activeNudge = (0, $42omo.useMemo)(()=>{
        // TODO: Remove when new consumers can safely use recommendations without exceeding request rate limits
        // Temporary: added search to skip nudge BE
        if (product !== 'confluence' || pageUrl.includes('/wiki/search')) return selectedNudges.filter((nudge)=>!dismissedNudges.includes(nudge.id) && !acceptedNudges.includes(nudge.id))[0] ?? null;
        if (loading || error || !recommendations?.length || !selectedNudges?.length) return null;
         // TODO: dismiss/accept nudge by its nudgeContext.id so we only need to check recommendations
        // Remove conversation starter if dismissed or accepted
        const availableRecommendations = recommendations.filter((recommendation)=>!dismissedNudges.includes(recommendation.feature_details.feature_id) && !acceptedNudges.includes(recommendation.feature_details.feature_id)); // Remove actions if dismissed or accepted
        const availableNudges = selectedNudges.filter((nudge)=>!dismissedNudges.includes(nudge.id) && !acceptedNudges.includes(nudge.id));
        const nudge = (0, $8d5bf81296446f89$export$6c62f9c964ed3ae0)(availableRecommendations, availableNudges) ?? null;
        if (nudge?.id === (0, $8Uc75.CONVO_STARTER_ID)) return {
            ...nudge,
            secondaryTitle: formatMessage($2b8cbdbf5555f0cb$var$messages.convoStarterSubheader)
        };
        return nudge;
    }, [
        acceptedNudges,
        dismissedNudges,
        error,
        loading,
        product,
        recommendations,
        selectedNudges,
        formatMessage,
        pageUrl
    ]);
    // Notify parent about active nudge state
    (0, $42omo.useEffect)(()=>{
        onActiveNudgeChange?.(Boolean(activeNudge));
    }, [
        activeNudge,
        onActiveNudgeChange
    ]); // Early exit if no nudge to show
    if (!activeNudge) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Suspense, {
        fallback: null,
        children: /*#__PURE__*/ (0, $l998X.jsx)($2b8cbdbf5555f0cb$var$LazyAIProactiveNudge, {
            activeNudge: activeNudge,
            addAcceptedNudge: addAcceptedNudge,
            addDismissedNudge: addDismissedNudge
        })
    });
};


const $c6dba64ff693e66f$var$i18n = (0, $aXWIB.defineMessages)({
    tooltipLabel: {
        id: "ai-smart-button.tooltip.label",
        defaultMessage: "Ask Rovo AI"
    },
    tooltipUnreadSuffix: {
        id: "ai-smart-button.tooltip.unread-suffix",
        defaultMessage: "{count, plural, one {# unread} other {# unread}}"
    },
    tooltipInProgress: {
        id: "ai-smart-button.tooltip.in-progress",
        defaultMessage: "{count, plural, one {# task in progress} other {# tasks in progress}}"
    }
});
const $c6dba64ff693e66f$var$styles = {
    buttonWrapper: "_kqswh2mm",
    tooltipContent: "_y3gn1e5h",
    tooltipInProgressLine: "_zg8l1m30"
};
const $c6dba64ff693e66f$var$EDIT_PAGE_MODE = 'edit';
const $c6dba64ff693e66f$export$21695acdb18697b9 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ onClick: onClick, isDisabled: isDisabled, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave }, ref)=>{
    const { sidebarApi: sidebarApi, analyticsAttributes: analyticsAttributes, product: product, productPage: productPage, pageMode: pageMode, getActions: getActions } = (0, $2sBZP.useAISmartButtonContext)(); // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const isUnreadIndicatorEnabled = (0, $c6GJD.default).getExperimentValue('rovo_button_unread_indicator', 'isEnabled', false);
    const { hasUnread: hasUnread, unreadCount: unreadCount, inProgressCount: inProgressCount } = (0, $9b7a6173fd2ba65c$export$e34a0a17cdc941c7)({
        enabled: isUnreadIndicatorEnabled
    });
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { toggleConversationAssistantUIMode: toggleConversationAssistantUIMode } = (0, $8unJx.useRovoExperienceAPIStore)();
    const [canShowNudge, setCanShowNudge] = (0, $42omo.useState)(false);
    const [spotlightRendered, setSpotlightRendered] = (0, $42omo.useState)(false);
    const [hasActiveNudge, setHasActiveNudge] = (0, $42omo.useState)(false);
    const [isHovering, setIsHovering] = (0, $42omo.useState)(false);
    const [actionShortcuts, setActionShortcuts] = (0, $42omo.useState)([]);
    const placementElementRef = (0, $42omo.useRef)(null);
    const hoverTimeoutRef = (0, $42omo.useRef)();
    const onboardingSpotlightElementId = (0, $42omo.useMemo)(()=>{
        const isLiveOrEditPage = analyticsAttributes?.pageMode === 'live' || analyticsAttributes?.pageMode === 'edit';
        const isPageOrBlogpost = productPage === 'page' || productPage === 'blogpost';
        if (isPageOrBlogpost && isLiveOrEditPage) return `rovo-button-onboarding-spotlight-live-or-edit`;
        return `rovo-button-onboarding-spotlight`;
    }, [
        productPage,
        analyticsAttributes
    ]); // Fetch action shortcuts when experiment is enabled
    const slaOperationsEnabled = (0, $dh538.fg)('jmb-4989_add_sla_operations_in_rovo');
    (0, $42omo.useEffect)(()=>{
        // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        const confluenceShortcutsEnabled = (0, $c6GJD.default).getExperimentValue('confluence_rovo_button_shortcuts_editor_only', 'isEnabled', false) === true;
        const shouldFetch = getActions && (confluenceShortcutsEnabled || product === 'jira');
        if (shouldFetch) getActions().then((actions)=>{
            // Filter to only get actions that can be used as shortcuts (Base, Chat, or Skill e.g. Jira SLA when feature-flagged)
            const shortcuts = actions.filter((action)=>action.handleType === (0, $6Htct.HandleActionType).Base || action.handleType === (0, $6Htct.HandleActionType).Chat || slaOperationsEnabled && action.handleType === (0, $6Htct.HandleActionType).Skill);
            const slicedShortcuts = shortcuts.slice(0, 3);
            setActionShortcuts(slicedShortcuts);
        }).catch(()=>{
            setActionShortcuts([]);
        });
    }, [
        getActions,
        product,
        slaOperationsEnabled
    ]); // Handle "Get Started" button click from spotlight
    const handleGetStartedClick = (0, $42omo.useCallback)(()=>{
        if (sidebarApi) toggleConversationAssistantUIMode({
            targetMode: 'mini-modal',
            sidebarApi: sidebarApi
        });
    }, [
        sidebarApi,
        toggleConversationAssistantUIMode
    ]); // Set up event listeners for spotlight communication
    (0, $42omo.useEffect)(()=>{
        if (!(0, $b154a53ccf449036$export$4e09c449d6c407f7)() || !placementElementRef.current || !(0, $dh538.fg)('rovo_button_onboarding_spotlight')) return;
        const doc = (0, $hTKp4.getDocument)();
        if (!doc) return;
         // Listen for spotlight rendered event
        const handleSpotlightRendered = (event)=>{
            const customEvent = event;
            if (customEvent.detail?.elementId === onboardingSpotlightElementId) setSpotlightRendered(true);
        }; // Listen for "Get Started" button click event
        const handleGetStartedEvent = (event)=>{
            const customEvent = event;
            if (customEvent.detail?.elementId === onboardingSpotlightElementId) handleGetStartedClick();
        };
        const unbind = (0, $fFa3V.bindAll)(doc, [
            {
                type: 'rovo-button-onboarding-spotlight-rendered',
                listener: handleSpotlightRendered
            },
            {
                type: 'rovo-button-onboarding-spotlight-get-started-click',
                listener: handleGetStartedEvent
            }
        ]);
        return ()=>{
            unbind();
        };
    }, [
        handleGetStartedClick,
        onboardingSpotlightElementId
    ]);
    (0, $42omo.useEffect)(()=>{
        if (spotlightRendered) return;
        if (!(0, $dh538.fg)('rovo_button_onboarding_spotlight') && !canShowNudge) {
            setCanShowNudge(true);
            return;
        } // Give spotlight time to render (if it will) since it needs to run decisions logic
        const timeout = setTimeout(()=>{
            if (!spotlightRendered && !canShowNudge) setCanShowNudge(true);
        }, 1000);
        return ()=>clearTimeout(timeout);
    }, [
        spotlightRendered,
        canShowNudge
    ]);
    const nudgeOrPlacement = (0, $42omo.useMemo)(()=>{
        return /*#__PURE__*/ (0, $l998X.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
            children: [
                (0, $dh538.fg)('rovo_button_onboarding_spotlight') && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    id: onboardingSpotlightElementId,
                    ref: placementElementRef
                }),
                canShowNudge && /*#__PURE__*/ (0, $l998X.jsx)((0, $2b8cbdbf5555f0cb$export$50a342ac0fc7ff57), {
                    onActiveNudgeChange: setHasActiveNudge
                })
            ]
        });
    }, [
        canShowNudge,
        onboardingSpotlightElementId
    ]);
    const handleButtonMouseEnter = (0, $42omo.useCallback)(()=>{
        clearTimeout(hoverTimeoutRef.current);
        hoverTimeoutRef.current = setTimeout(()=>{
            setIsHovering(true);
        }, 250);
        onMouseEnter();
    }, [
        onMouseEnter
    ]);
    const handleButtonMouseLeave = (0, $42omo.useCallback)(()=>{
        clearTimeout(hoverTimeoutRef.current);
        hoverTimeoutRef.current = setTimeout(()=>{
            setIsHovering(false);
            onMouseLeave();
        }, 1000);
    }, [
        onMouseLeave
    ]);
    const handleActionBoxMouseEnter = (0, $42omo.useCallback)(()=>{
        clearTimeout(hoverTimeoutRef.current);
        setIsHovering(true);
    }, []);
    const handleActionBoxMouseLeave = (0, $42omo.useCallback)(()=>{
        clearTimeout(hoverTimeoutRef.current);
        hoverTimeoutRef.current = setTimeout(()=>{
            setIsHovering(false);
        }, 1000);
    }, []);
    const canShowActionShortcuts = (0, $42omo.useMemo)(()=>{
        // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        const confluenceShortcutsEnabled = (0, $c6GJD.default).getExperimentValue('confluence_rovo_button_shortcuts_editor_only', 'isEnabled', false) === true;
        const confluenceEditMode = pageMode?.toLowerCase() === $c6dba64ff693e66f$var$EDIT_PAGE_MODE && confluenceShortcutsEnabled;
        const jiraWithShortcuts = slaOperationsEnabled && product === 'jira' && actionShortcuts.length > 0;
        return (actionShortcuts.length > 0 && !hasActiveNudge && !spotlightRendered && (confluenceEditMode || jiraWithShortcuts)) === true;
    }, [
        actionShortcuts.length,
        hasActiveNudge,
        spotlightRendered,
        pageMode,
        product,
        slaOperationsEnabled
    ]);
    const actionShortcutsRendering = (0, $42omo.useMemo)(()=>{
        if (!isHovering || !canShowActionShortcuts) return null;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $1818afbf5519aa2a$export$fa41c7e6bc1d5bc2), {
            actionShortcuts: actionShortcuts,
            onMouseEnter: handleActionBoxMouseEnter,
            onMouseLeave: handleActionBoxMouseLeave
        });
    }, [
        isHovering,
        canShowActionShortcuts,
        actionShortcuts,
        handleActionBoxMouseEnter,
        handleActionBoxMouseLeave
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        space: "space.100",
        alignBlock: "center",
        xcss: $c6dba64ff693e66f$var$styles.buttonWrapper,
        children: [
            nudgeOrPlacement,
            /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                position: "left",
                content: /*#__PURE__*/ (0, $l998X.jsxs)("div", {
                    className: (0, $gMc0m.default)([
                        $c6dba64ff693e66f$var$styles.tooltipContent
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)("div", {
                            children: hasUnread ? `${formatMessage($c6dba64ff693e66f$var$i18n.tooltipLabel)} \u{2022} ${formatMessage($c6dba64ff693e66f$var$i18n.tooltipUnreadSuffix, {
                                count: unreadCount
                            })}` : formatMessage($c6dba64ff693e66f$var$i18n.tooltipLabel)
                        }),
                        inProgressCount > 0 && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                            className: (0, $gMc0m.default)([
                                $c6dba64ff693e66f$var$styles.tooltipInProgressLine
                            ]),
                            children: formatMessage($c6dba64ff693e66f$var$i18n.tooltipInProgress, {
                                count: inProgressCount
                            })
                        })
                    ]
                }),
                hideTooltipOnClick: true,
                ignoreTooltipPointerEvents: true,
                canAppear: ()=>{
                    // If control or not on editor surface, always show tooltip when no active nudge
                    // If treatment and on editor surface, show tooltip only when shortcuts cannot be shown
                    return !hasActiveNudge && !canShowActionShortcuts;
                },
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3DxCm.AIButton), {
                    onClick: onClick,
                    isDisabled: isDisabled,
                    hasUnread: hasUnread,
                    onMouseEnter: handleButtonMouseEnter,
                    onMouseLeave: handleButtonMouseLeave,
                    ref: ref
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $g9Srd.default), {
                appear: true,
                children: actionShortcutsRendering
            })
        ]
    });
});


function $28312c7c4d66f65e$var$safeIsPointInRange(range, node, offset) {
    try {
        return range.isPointInRange(node, offset);
    } catch  {
        // some node types can throw, treat as "outside"
        return false;
    }
}
function $28312c7c4d66f65e$var$fullyInside(r, container) {
    return $28312c7c4d66f65e$var$safeIsPointInRange(container, r.startContainer, r.startOffset) && $28312c7c4d66f65e$var$safeIsPointInRange(container, r.endContainer, r.endOffset);
}
/**
 * Find the "main" ProseMirror for a given sidebar container:
 * Walk up from the sidebar to the nearest .ak-editor-content-area. Return its direct
 * child .ProseMirror (even if other editors exist deeper in the subtree).
 */ function $28312c7c4d66f65e$var$getMainProseMirrorForSidebar(sidebar) {
    const sidebarEl = typeof sidebar === 'string' && typeof document !== 'undefined' ? document.querySelector(sidebar) : sidebar;
    if (!sidebarEl) return null;
    const contentArea = sidebarEl.closest('.ak-editor-content-area');
    if (!contentArea) return null;
    for (const child of Array.from(contentArea.children)){
        if (child instanceof HTMLElement && child.classList.contains('ProseMirror')) return child;
    }
    return null;
}
function $28312c7c4d66f65e$var$countWords(text) {
    const t = text.trim();
    if (!t) return 0;
    try {
        const Segmenter = Intl?.Segmenter;
        if (Segmenter) {
            const seg = new Segmenter(undefined, {
                granularity: 'word'
            });
            let c = 0;
            for (const { isWordLike: isWordLike } of seg.segment(t))if (isWordLike) c++;
            return c;
        }
    } catch  {}
    // @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    return t.split(/\s+/u).filter(Boolean).length;
}
function $28312c7c4d66f65e$export$f18468c773f95821(sidebar) {
    try {
        const editor = $28312c7c4d66f65e$var$getMainProseMirrorForSidebar(sidebar);
        if (!editor) return null;
        const doc = editor.ownerDocument ?? (typeof document !== 'undefined' ? document : null);
        if (!doc) return null;
        const sel = doc.getSelection?.();
        if (!sel || sel.rangeCount === 0 || sel.isCollapsed) return null;
        // range covering just the editor's contents to test containment
        const container = doc.createRange();
        container.selectNodeContents(editor);
        // snapshot rangeCount up-front to avoid races if selection changes
        const rangeCount = sel.rangeCount;
        // require every selection range to be fully inside
        let text = '';
        for(let i = 0; i < rangeCount; i++){
            const r = sel.getRangeAt(i);
            if (!$28312c7c4d66f65e$var$fullyInside(r, container)) return null;
            const part = r.toString();
            text += text ? `\n${part}` : part;
        }
        return {
            text: text,
            words: $28312c7c4d66f65e$var$countWords(text),
            chars: text.length
        };
    } catch (err) {
        return null;
    }
}


const $683d8974f1c85970$var$ANIMATION_DURATION = 150;
const $683d8974f1c85970$var$styles = {
    wrapper: "_kqswh2mm",
    animatedMiniModalBefore: "_v564gsou _8hrz1x0m _3um015vq _tzy42wxo _t9ec1u4m _kdam1pry _m6k413u5 _sedt6rww",
    animatedMiniModalAfter: "_tzy4kb7n _t9ec1h7a _3um0ewfl _kdam1ogz"
};
const $683d8974f1c85970$export$2b989c5e58d6ba9 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ isDisabled: isDisabled = false, ...contextProps }, forwardedRef)=>{
    const { product: product, sidebarApi: sidebarApi, productPage: productPage, analyticsAttributes: analyticsAttributes } = contextProps;
    const hoverTimerRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(null);
    const { fireRovoButtonUIEvent: fireRovoButtonUIEvent } = (0, $4Zhx7.useRovoButtonEventsInstrumentation)();
    const { setButtonClickedTimestamp: setButtonClickedTimestamp } = (0, $ee1acdbba6f5287a$export$cb9c0d3b5896f957)();
    const { mode: mode, toggleConversationAssistantUIMode: toggleConversationAssistantUIMode, setIsMiniModalAvailable: setIsMiniModalAvailable } = (0, $8unJx.useRovoExperienceAPIStore)();
    const prevModeRef = (0, $42omo.useRef)(mode);
    const [rovoButtonCanRender, setRovoButtonCanRender] = (0, $42omo.useState)(mode !== 'mini-modal');
    const [hasStartedPreloading, setHasStartedPreloading] = (0, $42omo.useState)(false);
    (0, $8a1c9f7e7547dacb$export$a8ab20a5170c41b3)();
    (0, $42omo.useEffect)(()=>{
        setIsMiniModalAvailable(true);
        if (!(0, $b154a53ccf449036$export$4e09c449d6c407f7)()) return;
        // Start preloading when mouse is within the bottom-right box (300px from bottom, 300px from right)
        const handleMouseMove = (event)=>{
            if ((0, $b154a53ccf449036$export$4e09c449d6c407f7)() && !hasStartedPreloading) {
                const viewportHeight = window.innerHeight;
                const viewportWidth = window.innerWidth;
                const mouseY = event.clientY;
                const mouseX = event.clientX;
                const distanceFromBottom = viewportHeight - mouseY;
                const distanceFromRight = viewportWidth - mouseX;
                if (distanceFromBottom <= 300 && distanceFromRight <= 300) {
                    (0, $6aab261d18fe5fed$export$1f1f17d801cbb952)();
                    setHasStartedPreloading(true);
                }
            }
        };
        const unbind = (0, $fFa3V.bindAll)(window, [
            {
                type: 'mousemove',
                listener: handleMouseMove
            }
        ]);
        return ()=>{
            setIsMiniModalAvailable(false);
            (0, $b154a53ccf449036$export$4e09c449d6c407f7)() && unbind();
        };
    }, [
        setIsMiniModalAvailable,
        hasStartedPreloading
    ]);
    (0, $42omo.useEffect)(()=>{
        fireRovoButtonUIEvent({
            source: productPage,
            action: 'rendered',
            actionSubject: 'rovoButton',
            actionSubjectId: 'aiSmartButton',
            attributes: {
                product: product,
                productPage: productPage,
                ...analyticsAttributes,
                version: 'refresh',
                legacy: false
            },
            product: product
        });
    }, [
        fireRovoButtonUIEvent,
        product,
        productPage,
        analyticsAttributes
    ]);
    (0, $42omo.useEffect)(()=>{
        // Wait for the closing animation of modal to complete before showing the rovo button
        if (mode !== 'mini-modal') {
            setTimeout(()=>{
                setRovoButtonCanRender(true);
            }, $683d8974f1c85970$var$ANIMATION_DURATION);
            return;
        }
        setRovoButtonCanRender(false);
    }, [
        mode,
        setRovoButtonCanRender
    ]);
    (0, $42omo.useEffect)(()=>{
        if (mode === undefined && (prevModeRef.current === 'mini-modal' || prevModeRef.current === 'sidebar')) // AISmartButtonUI is unmounted while mini-modal or sidebar is open, so the hook
        // cannot watch mode internally. Mark cache stale here so the button remounts with
        // stale data visible while the background re-fetch completes.
        (0, $9b7a6173fd2ba65c$export$5ea316be7514c402)();
        prevModeRef.current = mode;
    }, [
        mode
    ]);
    const onAISmartButtonClick = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((e)=>{
        // Set timestamp immediately on click
        setButtonClickedTimestamp(Date.now());
        toggleConversationAssistantUIMode({
            targetMode: 'mini-modal',
            sidebarApi: sidebarApi
        });
        const selectionAttributes = {};
        if ((0, $dh538.fg)('platform_editor_ai_aifc_streaming')) {
            const counts = (0, $28312c7c4d66f65e$export$f18468c773f95821)(e.currentTarget);
            if (counts != null) {
                selectionAttributes.totalSelectedWords = counts.words;
                selectionAttributes.totalSelectedChars = counts.chars;
            }
        }
        fireRovoButtonUIEvent({
            source: productPage,
            action: 'clicked',
            actionSubject: 'rovoButton',
            actionSubjectId: 'aiRovoSmartButton',
            attributes: {
                product: product,
                productPage: productPage,
                ...analyticsAttributes,
                ...selectionAttributes,
                version: 'refresh'
            },
            product: product
        });
        setRovoButtonCanRender(false);
    }, [
        product,
        productPage,
        analyticsAttributes,
        fireRovoButtonUIEvent,
        toggleConversationAssistantUIMode,
        sidebarApi,
        setButtonClickedTimestamp
    ]);
    const onAISmartButtonEnter = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback(()=>{
        hoverTimerRef.current = setTimeout(()=>{
            fireRovoButtonUIEvent({
                source: productPage,
                action: 'hovered',
                actionSubject: 'rovoButton',
                actionSubjectId: 'aiSmartButton',
                attributes: {
                    product: product,
                    productPage: productPage,
                    ...analyticsAttributes,
                    version: 'refresh'
                },
                product: product
            });
        }, 1000);
    }, [
        fireRovoButtonUIEvent,
        product,
        productPage,
        analyticsAttributes
    ]);
    const onAISmartButtonLeave = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback(()=>{
        if (hoverTimerRef.current) {
            clearTimeout(hoverTimerRef.current);
            hoverTimerRef.current = null;
        }
    }, []);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $2sBZP.AISmartButtonProvider), {
                ...contextProps,
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                    xcss: $683d8974f1c85970$var$styles.wrapper,
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: (0, $1Whri.cx)($683d8974f1c85970$var$styles.animatedMiniModalBefore, mode === 'mini-modal' && $683d8974f1c85970$var$styles.animatedMiniModalAfter),
                            children: !sidebarApi.isSidebarOpen() && !rovoButtonCanRender && /*#__PURE__*/ (0, $l998X.jsx)((0, $6aab261d18fe5fed$export$f36d8da28b18d2c1), {})
                        }),
                        !sidebarApi.isSidebarOpen() && rovoButtonCanRender && /*#__PURE__*/ (0, $l998X.jsx)((0, $c6dba64ff693e66f$export$21695acdb18697b9), {
                            ref: forwardedRef,
                            onClick: onAISmartButtonClick,
                            isDisabled: isDisabled,
                            onMouseEnter: onAISmartButtonEnter,
                            onMouseLeave: onAISmartButtonLeave
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $635ac85d8e192d37$export$20c376cddbc7272c), {
                product: product
            })
        ]
    });
});



var $7mpOv = parcelRequire("7mpOv");


var $bQm3c = parcelRequire("bQm3c");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $zCcSI = parcelRequire("zCcSI");


var $5ruin = parcelRequire("5ruin");


var $2bR8c = parcelRequire("2bR8c");

const $293253fb36609c97$var$styles = {
    smartButtonWrapperStyles: "_kqswstnw _1pby16oo _1xi2idpf _94n5idpf"
};
function $293253fb36609c97$export$f7d346730580e70({ contentId: contentId, contentType: contentType, pageMode: pageMode, isDisabled: isDisabled = false, isSidebarAvailable: isSidebarAvailable }) {
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const { isAIEnabledForContent: isAIEnabledForContent, isRovoEnabledForContent: isRovoEnabledForContent } = (0, $7mpOv.useIsAIEnabledForContent)({
        contentId: contentId
    });
    const sidebarApi = (0, $2bR8c.useCreateRovoExperienceSidebarController)();
    const getActions = (0, $5ruin.useRovoConfigGetActions)();
    const tags = (0, $5ruin.useRovoConfigTags)();
    const customGreeting = (0, $5ruin.useRovoConfigCustomGreeting)();
    const shouldShowGreeting = (0, $5ruin.useRovoConfigShouldShowGreeting)();
    const prioritizeCustomActionResults = (0, $5ruin.useRovoConfigPrioritizeCustomActionResults)();
    // environment-aware enablement via feature encoding
    const isAIEnvEnabled = (0, $5spQU.isFeatureEnabled)('confluence', 'confluence-ai');
    const isEnabled = isAIEnvEnabled && isAIEnabledForContent && isRovoEnabledForContent;
    // 48px = nav header height, 8px = object sidebar bottom padding, 16px = AI smart button bottom margin, 8px = extra margin so it doesn't align with nav header
    const navbarOffset = 80;
    // From confluence/next/packages/content-types-header/src/ContentTypesHeader.tsx
    const OBJECT_HEADER_CONTAINER_HEIGHT = 56;
    // From platform/packages/editor/editor-shared-styles/src/consts/consts.ts
    const FULL_PAGE_EDITOR_TOOLBAR_HEIGHT = 40;
    // Calculate total vertical offset based on the maximum header height (occurs in edit mode)
    const totalOffset = FULL_PAGE_EDITOR_TOOLBAR_HEIGHT + OBJECT_HEADER_CONTAINER_HEIGHT + navbarOffset;
    // Memoize analytics attributes to prevent unnecessary re-renders
    const analyticsAttributes = (0, $42omo.useMemo)(()=>({
            pageMode: pageMode
        }), [
        pageMode
    ]);
    const uiConfig = (0, $42omo.useMemo)(()=>({
            ...customGreeting ? {
                customGreeting: customGreeting
            } : {},
            ...shouldShowGreeting !== undefined ? {
                elements: {
                    shouldShowGreeting: shouldShowGreeting
                }
            } : {}
        }), [
        customGreeting,
        shouldShowGreeting
    ]);
    const overrideMiniModalWrapper = (0, $42omo.useMemo)(()=>(children)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                xcss: $293253fb36609c97$var$styles.smartButtonWrapperStyles
            }, children);
        }, []);
    const conversationAssistantConfig = (0, $zCcSI.useConversationAssistantConfig)({
        assistanceServiceConfigHeaders: {
            'x-issynthetic-traffic': 'false'
        },
        preventAbortRequestsOnStagingModalClose: true,
        preventAbortRequestsOnStandaloneChatClose: true
    });
    if (!isEnabled) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).AI_MATE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $683d8974f1c85970$export$2b989c5e58d6ba9), {
        product: "confluence",
        cloudId: cloudId,
        orgId: orgId,
        isNav4Enabled: true,
        sidebarApi: sidebarApi,
        productPage: contentType,
        pageMode: pageMode,
        analyticsAttributes: analyticsAttributes,
        isDisabled: isDisabled,
        isSidebarAvailable: isSidebarAvailable,
        topOffset: totalOffset,
        conversationAssistantConfig: conversationAssistantConfig,
        overrideMiniModalWrapper: overrideMiniModalWrapper,
        getActions: getActions,
        prioritizeCustomActionResults: prioritizeCustomActionResults,
        tags: tags,
        uiConfig: uiConfig
    }));
}
module.exports["AISmartButtonWrapper"] = $293253fb36609c97$export$f7d346730580e70;

});

parcelRegister("2sBZP", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $4423fa8f654a24b1$var$AISmartButtonContext = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $4423fa8f654a24b1$export$f3b20af08af21b9b = ({ children: children, ...props })=>{
    // We have to use Object.values to compare prop values instead of the props object reference,
    // which changes on every render due to the rest operator. Otherwise, the useMemo would be ineffective
    // since it compares object references, not their contents.
    const contextValue = (0, $42omo.useMemo)(()=>props, // eslint-disable-next-line react-hooks/exhaustive-deps
    Object.values(props));
    return /*#__PURE__*/ (0, $l998X.jsx)($4423fa8f654a24b1$var$AISmartButtonContext.Provider, {
        value: contextValue,
        children: children
    });
};
const $4423fa8f654a24b1$export$9b0f174637261634 = ()=>{
    const context = (0, $42omo.useContext)($4423fa8f654a24b1$var$AISmartButtonContext);
    if (!context) throw new Error('useAISmartButtonContext must be used within an AISmartButtonProvider');
    return context;
};
module.exports["AISmartButtonProvider"] = $4423fa8f654a24b1$export$f3b20af08af21b9b;
module.exports["useAISmartButtonContext"] = $4423fa8f654a24b1$export$9b0f174637261634;

});

parcelRegister("4Zhx7", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3pfAb = parcelRequire("3pfAb");


var $inPa6 = parcelRequire("inPa6");

const $4dadc02c4f362fc5$var$ANALYTICS_CHANNEL = (0, $3pfAb.FabricChannel).aiMate;
const $4dadc02c4f362fc5$export$8a94e432ef80d839 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireEventWithOptionalChannel = (0, $42omo.useCallback)((event, product)=>{
        const analyticsEvent = createAnalyticsEvent(event);
        if (product === 'confluence') {
            analyticsEvent.fire();
            return;
        }
        // it goes thru the aiMate analytics listener to avoid validation per product listener
        // https://bitbucket.org/atlassian/atlassian-frontend-mirror/src/f904f690cf57ef84acad6c7bf1b5bd90ad9cada2/analytics/analytics-listeners/src/atlaskit/process-event.ts#lines-58
        analyticsEvent.fire($4dadc02c4f362fc5$var$ANALYTICS_CHANNEL);
    }, [
        createAnalyticsEvent
    ]);
    const createEventPayload = (0, $42omo.useCallback)((payload)=>{
        if (payload.product === 'confluence') // confluence event validation frontend logic
        // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/f8bf8ba8c7b54c6e2764d85551b3f989b69d28d8/confluence/next/packages/analytics/src/analyticsListener.tsx#lines-53
        return {
            type: 'sendUIEvent',
            data: payload
        };
        if (payload.product === 'jira') // jira event validation frontend logic
        // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/f8bf8ba8c7b54c6e2764d85551b3f989b69d28d8/jira/src/packages/platform/observability/product-analytics-bridge/src/utils/extract-data-from-event.tsx#lines-164
        // it requires to use no more than 4 properties on the top level of event shape for custom event fire.
        return {
            actionSubject: payload.actionSubject,
            action: payload.action,
            actionSubjectId: payload.actionSubjectId,
            attributes: payload.attributes
        };
        // for any other product type we should use the default event shape
        // also if there is a custom event channel, we also should use the default event shape
        return {
            eventType: 'ui',
            ...payload
        };
    }, []);
    const fireRovoButtonUIEvent = (0, $42omo.useCallback)((eventData)=>{
        // Only fire the event if product is defined
        if (!eventData.product) return;
        const event = createEventPayload(eventData);
        fireEventWithOptionalChannel(event, eventData.product);
    }, [
        fireEventWithOptionalChannel,
        createEventPayload
    ]);
    return {
        fireRovoButtonUIEvent: fireRovoButtonUIEvent
    };
};
module.exports["useRovoButtonEventsInstrumentation"] = $4dadc02c4f362fc5$export$8a94e432ef80d839;

});

parcelRegister("avMJB", function(module, exports) {

let $7a729a4edaccf7a0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7a729a4edaccf7a0$var$load("7wimf").then(()=>parcelRequire('jK0BO'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("7cG9Q", function(module, exports) {

let $53ea5b0bbe64d704$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $53ea5b0bbe64d704$var$load("apVMV"),
    $53ea5b0bbe64d704$var$load("enf8i"),
    $53ea5b0bbe64d704$var$load("kKgDm")
]).then(()=>parcelRequire('011m2'));

});

parcelRegister("3DxCm", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $c6GJD = parcelRequire("c6GJD");


var $gdv5Z = parcelRequire("gdv5Z");

var $fVUfS = parcelRequire("fVUfS");


var $cOrQJ = parcelRequire("cOrQJ");


var $6F6hl = parcelRequire("6F6hl");

/* eslint-disable @atlaskit/design-system/ensure-design-token-usage -- Brand asset colors are intentionally static and not sourced from theme tokens. */ 


parcelRequire("42omo");

const $637a48a00cfebdb4$var$COLORS = {
    light: {
        blue: '#357DE8',
        green: '#82B536',
        purple: '#BF63F3',
        yellow: '#FCA700'
    },
    dark: {
        blue: '#1868DB',
        green: '#6A9A23',
        purple: '#AF59E0',
        yellow: '#FCA700'
    }
};
const $637a48a00cfebdb4$export$a6319ea655f8cd28 = ({ colorMode: colorMode })=>{
    const colors = $637a48a00cfebdb4$var$COLORS[colorMode] ?? $637a48a00cfebdb4$var$COLORS.light;
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        focusable: "false",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.2961 15.6713L4.10278 19.8244L2.66999 18.9977C1.82857 18.5126 1.30786 17.6127 1.30786 16.6431V7.36597C1.30786 6.39257 1.82552 5.49654 2.66944 5.01169L8.71294 1.5249C8.69954 1.56253 8.68676 1.60042 8.67462 1.63854C8.56274 1.9857 8.50344 2.35249 8.50344 2.7274V12.0045C8.50344 13.2789 9.18226 14.4544 10.2885 15.0902L11.2961 15.6713Z",
                fill: colors.blue
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.2961 15.6714L4.10278 19.8244L10.7097 23.6363C11.5361 24.1127 12.553 24.1212 13.3861 23.6616C13.4012 23.6499 13.4173 23.6391 13.4343 23.6293C14.0279 23.2871 14.462 22.7382 14.6662 22.1042C14.7492 21.8421 14.7932 21.5652 14.7932 21.2817V17.6881L11.2961 15.6714Z",
                fill: colors.green
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M21.4773 5.0024L19.9362 4.11328L12.7429 8.26635L13.8592 8.9101C14.9656 9.54588 15.644 10.7212 15.644 11.9956V21.2728C15.644 21.6482 15.5845 22.0155 15.4723 22.3631C15.4603 22.4007 15.4477 22.4381 15.4345 22.4753L21.478 18.9885C22.3219 18.5036 22.8395 17.6076 22.8395 16.6342V7.35706C22.8395 6.3875 22.3187 5.4875 21.4773 5.0024Z",
                fill: colors.purple
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.7406 8.26623L9.35181 6.31195V2.71837C9.35181 2.43521 9.39561 2.15859 9.47851 1.89674C9.68231 1.26299 10.1158 0.714353 10.7088 0.371866L10.7106 0.370829C10.7276 0.361021 10.7438 0.350143 10.7588 0.338447C11.592 -0.121106 12.6089 -0.112663 13.4353 0.363774L19.9339 4.11316L12.7406 8.26623Z",
                fill: colors.yellow
            })
        ]
    });
};





parcelRequire("42omo");

const $737d2071d968b7f4$export$a0f6cb8061290bbb = ()=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        focusable: "false",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13.4352 0.363775C12.6088 -0.112663 11.592 -0.121106 10.7588 0.338447C10.7437 0.350143 10.7258 0.362058 10.7088 0.371866C10.1158 0.714353 9.68229 1.26299 9.47849 1.89674C9.39559 2.15859 9.35178 2.43521 9.35178 2.71837V6.31195L12.7406 8.26623L13.8592 8.91009C14.9656 9.54587 15.6439 10.7211 15.6439 11.9956V21.2728C15.6439 21.6482 15.5845 22.0155 15.4723 22.3631C15.4603 22.4007 15.4477 22.4381 15.4344 22.4753L21.4779 18.9885C22.3219 18.5036 22.8395 17.6076 22.8395 16.6342V7.35705C22.8395 6.38749 22.3187 5.48749 21.4773 5.00239L19.9351 4.11389L13.4352 0.363775Z",
                fill: "var(--ds-surface, #FFFFFF)"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M2.66999 18.9977L4.10278 19.8244L10.7097 23.6363C11.5361 24.1126 12.553 24.1211 13.3861 23.6616C13.4012 23.6499 13.4173 23.6391 13.4343 23.6293C14.0279 23.287 14.462 22.7382 14.6662 22.1042C14.7492 21.8421 14.7931 21.5651 14.7931 21.2817V17.6881L11.2961 15.6713L10.2885 15.0902C9.18226 14.4544 8.50344 13.2789 8.50344 12.0045V2.7274C8.50344 2.35249 8.56274 1.9857 8.67462 1.63854C8.68676 1.60041 8.69954 1.56253 8.71294 1.5249L2.66944 5.01169C1.82552 5.49653 1.30786 6.39257 1.30786 7.36597V16.6431C1.30786 17.6127 1.82857 18.5126 2.66999 18.9977Z",
                fill: "var(--ds-surface, #FFFFFF)"
            })
        ]
    });





const $505231ea686e75aa$var$_default_1 = (0, $aXWIB.defineMessages)({
    rovoButton: {
        id: "ai-smart-button.ai-button.button-label",
        defaultMessage: "Open Rovo Chat"
    }
});
var $505231ea686e75aa$export$2e2bcd8739ae039 = $505231ea686e75aa$var$_default_1;


const $8ae48bddb3670e27$var$atlaskitCssStyles = {
    pressableStyles: "_2rko1tm3 _1e0c1txw _4cvr1h6o _1bah1h6o _kqswh2mm _4t3ickbl _1bsbckbl _bfhk1j28",
    boxStyles: "_2rko1tm3 _v564s58n _1bsbckbl _4t3ickbl _1o9zidpf _kqswh2mm _bfhk1aqn _16qs1a41 _m6k41e03 _o7ksf4ca _1llw1mwg _d0altlke _1q8wws4j",
    logoWrapper: "_v564s58n _1e0c1txw _4cvr1h6o _1bah1h6o",
    unreadDot: "_2rko1rr0 _kqswstnw _94n512x7 _1ltv1ssb _t9eczr6s _1bsb1y44 _4t3i1y44 _bfhkysee _lcxvglyw"
};
const $8ae48bddb3670e27$export$a51986b9c6d9ac89 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ onClick: onClick, isDisabled: isDisabled, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, hasUnread: hasUnread }, ref)=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { colorMode: colorMode } = (0, $cOrQJ.default)(); // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const isRovoButtonVisibilityExperimentEnabled = (0, $c6GJD.default).getExperimentValue('rovo_button_visibility_improvements', 'isEnabled', false); // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const isRovoButtonVisibilityExtendedEnabled = (0, $c6GJD.default).checkGate('rovo_button_visibility_improvements_extended');
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        xcss: $8ae48bddb3670e27$var$atlaskitCssStyles.boxStyles,
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $fVUfS.default), {
                testId: "platform-ai-button",
                xcss: $8ae48bddb3670e27$var$atlaskitCssStyles.pressableStyles,
                onClick: onClick,
                isDisabled: isDisabled,
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                onFocus: onMouseEnter,
                onBlur: onMouseLeave,
                ref: ref,
                interactionName: "rovo-button-click",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6F6hl.default), {
                        children: formatMessage((0, $505231ea686e75aa$export$2e2bcd8739ae039).rovoButton)
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: $8ae48bddb3670e27$var$atlaskitCssStyles.logoWrapper,
                        style: {
                            transform: hasUnread ? 'scale(0.833) translateY(-3px)' : 'scale(1) translateY(0)'
                        },
                        children: isRovoButtonVisibilityExperimentEnabled || isRovoButtonVisibilityExtendedEnabled ? /*#__PURE__*/ (0, $l998X.jsx)((0, $637a48a00cfebdb4$export$a6319ea655f8cd28), {
                            colorMode: colorMode === 'dark' ? 'dark' : 'light'
                        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $737d2071d968b7f4$export$a0f6cb8061290bbb), {})
                    })
                ]
            }),
            hasUnread && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $8ae48bddb3670e27$var$atlaskitCssStyles.unreadDot,
                testId: "ai-button-unread-dot",
                "aria-hidden": "true"
            })
        ]
    });
});
module.exports["AIButton"] = $8ae48bddb3670e27$export$a51986b9c6d9ac89;

});

parcelRegister("8Uc75", function(module, exports) {
const $23b2c9d779d9d9b9$export$9ccb14fef330e4ca = 'convo-starter';
const $23b2c9d779d9d9b9$export$117ec3655363b13c = 'summarize-changes-ai-action';
const $23b2c9d779d9d9b9$export$7728198680150ac4 = 'jira-board-catch-up-rovo-nudge';
const $23b2c9d779d9d9b9$export$1ef7a1ab75cdd715 = 'similar-work-items-nudge';
const $23b2c9d779d9d9b9$export$5aed500badbb741e = 'audio-briefing-ai-action';
module.exports["CONVO_STARTER_ID"] = $23b2c9d779d9d9b9$export$9ccb14fef330e4ca;
module.exports["SUMMARIZE_CHANGES_ID"] = $23b2c9d779d9d9b9$export$117ec3655363b13c;
module.exports["JIRA_BOARD_CATCH_UP_ID"] = $23b2c9d779d9d9b9$export$7728198680150ac4;
module.exports["SIMILAR_WORK_ITEMS_ID"] = $23b2c9d779d9d9b9$export$1ef7a1ab75cdd715;
module.exports["AUDIO_BRIEFING_ID"] = $23b2c9d779d9d9b9$export$5aed500badbb741e;

});

parcelRegister("3xhLJ", function(module, exports) {

let $29323cabd990c071$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $29323cabd990c071$var$load("apVMV"),
    $29323cabd990c071$var$load("enf8i"),
    $29323cabd990c071$var$load("eKfu4")
]).then(()=>parcelRequire('5ktPP'));

});


//# sourceMappingURL=ObjectSidebarControl.bb3915fa.js.map
